import type { NextPage } from 'next';
import { Box } from '@chakra-ui/react';
import NextHead from 'next/head';
import CommunityGuidelines from '../../components/CommunityGuidelines';
import { title } from '../../common/libs/metadata';
import { getPublicRuntimeConfig } from '../../common/config';

export { getServerSideProps } from '../../server/serverSideProps/emptyWithAuth';

const CommunityGuidelinesPage: NextPage = () => {
  const { slideWebBaseUrl } = getPublicRuntimeConfig();
  const canonicalUrl = `${slideWebBaseUrl}/docs/community-guidelines`;
  return (
    <>
      <NextHead>
        <title>{title('Antaaコミュニティガイドライン')}</title>
        <link rel="canonical" href={canonicalUrl} />
      </NextHead>
      <Box>
        <CommunityGuidelines />
      </Box>
    </>
  );
};

export default CommunityGuidelinesPage;
